// eslint-disable-next-line import/no-unresolved
import { EffectFade } from 'swiper/modules';
import { convertQuerySelectorAll } from '../../../../src/js/components/helpers';

type SwiperElement = HTMLElement & {
	swiper?: InstanceType<typeof window.Swiper>;
	swiperObserver?: IntersectionObserver;
};

convertQuerySelectorAll('.block-content-scroller .content-scroller-slider', (elements) => {
	elements.forEach((element) => {
		const swiperElement = element as SwiperElement;

		// Destroy existing Swiper instance and observer if they exist.
		if (swiperElement.swiperObserver) {
			swiperElement.swiperObserver.disconnect();
		}
		if (swiperElement.swiper) {
			swiperElement.swiper.destroy(true, true);
		}

		const swiper = new window.Swiper(swiperElement, {
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 20,
			allowTouchMove: false,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			modules: [EffectFade],
		});

		// Set up the observer for this slider.
		const contentScrollerSliderIndex: { [key: string]: number } = {};
		swiper.slides.forEach((item: HTMLElement, index: number) => {
			const blockID = item.getAttribute('data-block-id') as string;
			contentScrollerSliderIndex[blockID] = index;
		});

		const observerCallback = (entries: Array<IntersectionObserverEntry>) => {
			entries.forEach((entry: IntersectionObserverEntry) => {
				if (entry.isIntersecting) {
					swiper.slideTo(contentScrollerSliderIndex[entry.target.id]);
				}
			});
		};

		const observer = new IntersectionObserver(observerCallback, {
			rootMargin: '-50% 0px -50% 0px',
			threshold: 0,
		});

		// Store observer reference for cleanup.
		swiperElement.swiperObserver = observer;

		const sliderItems: NodeListOf<HTMLElement> | undefined = swiperElement
			?.closest('.block-content-scroller')
			?.querySelectorAll('.block-content-scroll-item');

		if (sliderItems) {
			sliderItems.forEach((scroller: HTMLElement) => {
				if (scroller) {
					observer.observe(scroller);

					// Manually trigger the callback if it's already in view.
					const rect = scroller.getBoundingClientRect();
					if (rect.top < window.innerHeight && rect.bottom > 0) {
						swiper.slideTo(contentScrollerSliderIndex[scroller.id]);
					}
				}
			});
		}
	});
});
